<template>
    <div>
        <button v-if="successful !== true"
                class="btn btn-sm btn-outline-secondary"
                type="button"
                :disabled="testing"
                @click="testConnection"
        >
            <i class="fas fa-server"/>
            {{ __('actions.start_thing', {thing: __('general.api.settings_test')}) }}
        </button>
        <div v-if="successful === true" class="p-1 font-size-lg text-success user-select-none">
            <i class="fas fa-check-circle"/>
            {{ __('general.thing.successful', {thing: __('general.api.connection')}) }}
        </div>
        <div v-if="successful === false" class="p-1 font-size-lg text-danger user-select-none">
            <i class="fas fa-times-circle"/>
            {{ __('general.thing.failed', {thing: __('general.api.connection')}) }}
        </div>
    </div>
</template>

<script>
import IntegrationRoutesMixin from "@mixins/IntegrationRoutesMixin";

export default {
    mixins: [IntegrationRoutesMixin],

    props: {
        integration: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            successful: null,
            testing: false,
        }
    },

    methods: {
        testConnection() {
            this.testing = true;
            axios.post(this.integrationRoute('api'), {
                host: this.config.hiltes_api_host,
                user: this.config.hiltes_api_user,
                password: this.config.hiltes_api_pw,
            }).then(response => {
                this.testing = false;
                this.successful = true;
            }).catch(error => {
                this.testing = false;
                this.successful = false;
            });
        }
    }
}
</script>
